(function () {
  function normaliseQuantity(value) {
    const qty = parseInt(value, 10);
    return Number.isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function setButtonState(button, text, disabled) {
    if (!button) return;
    button.textContent = text;
    button.disabled = Boolean(disabled);
  }

  function getCartAddUrl() {
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root + 'cart/add.js';
  }

  function ensureCartBar() {
    let bar = document.querySelector('[data-dv-cart-bar]');

    if (bar) return bar;

    bar = document.createElement('div');
    bar.setAttribute('data-dv-cart-bar', '');
    bar.style.position = 'fixed';
    bar.style.right = '18px';
    bar.style.bottom = '18px';
    bar.style.zIndex = '9999';
    bar.style.display = 'flex';
    bar.style.alignItems = 'center';
    bar.style.gap = '12px';
    bar.style.padding = '12px 16px';
    bar.style.borderRadius = '999px';
    bar.style.background = '#111';
    bar.style.color = '#fff';
    bar.style.fontSize = '14px';
    bar.style.boxShadow = '0 8px 24px rgba(0,0,0,0.18)';

    bar.innerHTML =
      '<span data-dv-cart-bar-count>Cart updated</span>' +
      '<a href="/cart" style="color:#fff;text-decoration:underline;font-weight:600;">View cart</a>';

    document.body.appendChild(bar);
    return bar;
  }

  function updateCartBar() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      })
      .then(function (cart) {
        const bar = ensureCartBar();
        const countText = bar.querySelector('[data-dv-cart-bar-count]');

        if (countText) {
          countText.textContent = 'Cart: ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
        }

        return cart;
      });
  }

  document.addEventListener('click', function (event) {
    const qtyButton = event.target.closest('[data-dv-qty-minus], [data-dv-qty-plus]');
    const addButton = event.target.closest('[data-dv-add-cart]');

    if (qtyButton) {
      const wrapper = qtyButton.closest('[data-dv-collection-cart]');
      if (!wrapper) return;

      event.preventDefault();

      const input = wrapper.querySelector('[data-dv-qty-input]');
      if (!input) return;

      let currentQty = normaliseQuantity(input.value);

      if (qtyButton.matches('[data-dv-qty-minus]')) {
        currentQty = Math.max(1, currentQty - 1);
      }

      if (qtyButton.matches('[data-dv-qty-plus]')) {
        currentQty = currentQty + 1;
      }

      input.value = currentQty;
      return;
    }

    if (addButton) {
      const wrapper = addButton.closest('[data-dv-collection-cart]');
      if (!wrapper) return;

      event.preventDefault();

      const variantId = wrapper.getAttribute('data-variant-id');
      const input = wrapper.querySelector('[data-dv-qty-input]');
      const quantity = normaliseQuantity(input ? input.value : 1);

      if (!variantId) {
        setButtonState(addButton, 'Try again', false);
        return;
      }

      setButtonState(addButton, 'Adding...', true);

      fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: quantity
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          return updateCartBar();
        })
        .then(function () {
          setButtonState(addButton, 'Added ✓', true);

          setTimeout(function () {
            setButtonState(addButton, 'Add to cart', false);
          }, 1200);
        })
        .catch(function () {
          setButtonState(addButton, 'Try again', false);

          setTimeout(function () {
            setButtonState(addButton, 'Add to cart', false);
          }, 1600);
        });
    }
  });

    document.addEventListener('change', function (event) {
    const input = event.target.closest('[data-dv-qty-input]');
    if (!input) return;
    input.value = normaliseQuantity(input.value);
  });
})();